// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Y2-z","colorTextValue":"Z2-z","swatches":"_2-z","collapseLink":"a3-z","isCollapsed":"b3-z","dropdown":"c3-z","disabled":"d3-z"};